import React from "react";
import noRefundPolicy from "./data/data";
import { FaCircleDot } from "react-icons/fa6";
import { IoIosMail } from "react-icons/io";
import MainLayout from "../../layouts/MainLayOut";

function Refund() {
  return (
    <MainLayout>
      <div className=" flex flex-col">
        <div
          className="flex-1 py-10 px-4 sm:px-8 md:px-16 2xl:px-[10vw] text-slate-300"
          style={{
            background:
              "radial-gradient(circle, rgba(51, 65, 85,1) 1%, rgba(2, 6, 23,1) 92%)",
          }}>
          {/* Header */}
          <div className="mb-8">
            <h1 className="text-slate-50 font-bold text-3xl sm:text-4xl 2xl:text-[3vw] 2xl:leading-[3.5vw]">
              {noRefundPolicy.title}
            </h1>
            <p className="text-xs sm:text-sm mt-1 text-slate-400 2xl:text-[1.1vw] 2xl:leading-[1.3vw]">
              {noRefundPolicy.effectiveDate}
            </p>
          </div>

          {/* Sections */}
          <div className="flex flex-col gap-6 text-sm sm:text-base 2xl:text-[1.1vw] 2xl:leading-[1.4vw]">
            {noRefundPolicy.sections.map((ele, ind) => (
              <div key={ind} className="border-l-4 border-slate-700 pl-4">
                <h2 className="text-lg font-semibold text-slate-100 mb-2">
                  {ind + 1}. {ele?.heading}
                </h2>

                <div className="flex flex-col gap-4 ml-2">
                  <p>{ele?.content}</p>

                  {/* Exceptions */}
                  {ele?.exceptions && (
                    <div className="flex flex-col gap-3 ml-4">
                      {ele.exceptions.map((exception, idx) => (
                        <div key={idx}>
                          <div className="flex items-start gap-2 font-semibold text-slate-200">
                            <FaCircleDot className="min-w-4 mt-1" />
                            {exception.title}
                          </div>
                          <p className="ml-6">{exception.description}</p>
                          {exception.conditions && (
                            <ul className="ml-8 list-disc text-slate-300">
                              {exception.conditions.map((condition, i) => (
                                <li key={i}>{condition}</li>
                              ))}
                            </ul>
                          )}
                        </div>
                      ))}
                    </div>
                  )}

                  {/* Refund Criteria */}
                  {ele?.refundCriteria?.length > 0 && (
                    <ul className="ml-6 flex flex-col gap-1">
                      {ele.refundCriteria.map((item, i) => (
                        <li
                          key={i}
                          className="list-none flex gap-2 items-start">
                          <FaCircleDot className="mt-1 text-sky-400" />
                          <span>
                            <span className="font-medium">
                              {item.condition}
                            </span>{" "}
                            ={" "}
                            <span className="text-slate-200">
                              {item.refund}
                            </span>
                          </span>
                        </li>
                      ))}
                    </ul>
                  )}

                  {/* Optional Fields */}
                  {ele.processingTime && (
                    <p className="italic text-slate-400">
                      {ele.processingTime}
                    </p>
                  )}

                  {ele.requestDetails?.length > 0 && (
                    <ul className="ml-6 list-disc text-slate-300">
                      {ele.requestDetails.map((detail, i) => (
                        <li key={i}>{detail}</li>
                      ))}
                    </ul>
                  )}

                  {ele.instructions && (
                    <p className="text-slate-300">{ele.instructions}</p>
                  )}

                  {ele.email && (
                    <a
                      href={`mailto:${ele.email}`}
                      className="inline-flex gap-2 items-center mt-2 text-sky-400 hover:underline hover:text-sky-300">
                      <IoIosMail className="text-xl" />
                      {ele.email}
                    </a>
                  )}

                  {ele.copyright && (
                    <p className="text-slate-400 mt-2">{ele.copyright}</p>
                  )}

                  {ele.reviewTime && (
                    <div className="tracking-wide text-slate-400">
                      {ele.reviewTime}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </MainLayout>
  );
}

export default Refund;
